import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { CategoryFormValues } from "src/models/Category.model";

type Props = {
  formikProps: FormikProps<CategoryFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const CategoryForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          <div className="text-xl font-medium">
            {formType === "ADD"
              ? "Add category"
              : "Update category"}{" "}
          </div>
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="categoryName"
            required
            value={values.categoryName}
            onChange={(e) => {
              setFieldValue("categoryName", e.target.value);
            }}
            label="Category Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="categoryCode"
            required
            value={values.categoryCode}
            onChange={(e) => {
              setFieldValue("categoryCode", e.target.value);
            }}
            label="Category Code"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="rank"
            value={values.rank}
            onChange={(e) => {
              setFieldValue("rank", e.target.value);
            }}
            label="Rank"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default CategoryForm;
